import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectSelectedReturnIds = (state) => get(state, 'selectedReturnIds', emptyArray);
export const selectCount = (state) => get(selectSelectedReturnIds(state), 'length');
